const initialState = {}

export default function auth(state = initialState, action) {
  return state
}
